import { Container, Typography, Box, Divider, Link as JoyLink } from '@mui/joy';
import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { AppBasic } from '../../../components/app/App';

function PageChildSafety() {
    return (
        <AppBasic
            title="Стандарты безопасности детей"
            desc="Стандарты сервиса «Аквариум» по борьбе с сексуальным насилием над детьми и их эксплуатацией (CSAE): запрещённый контент, модерация, жалобы и реагирование."
        >
            <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
                <Link to="/legal" style={{ textDecoration: 'none' }}>
                    <Typography
                        startDecorator={<ArrowLeft size={20} />}
                        level="body-md"
                        sx={{ mb: 4, display: 'inline-flex', alignItems: 'center', gap: .5, '&:hover': { color: 'primary.plainColor' } }}
                    >
                        Назад к списку документов
                    </Typography>
                </Link>

                <Typography level="h1" sx={{ mb: 1 }}>
                    Стандарты безопасности детей
                </Typography>
                <Typography sx={{ mb: 5, color: 'text.tertiary' }}>
                    Последнее обновление: июнь 2026 г.
                </Typography>

                <Box sx={{
                    bgcolor: 'background.surface',
                    p: { xs: 3, md: 6 },
                    borderRadius: '24px',
                    lineHeight: 1.85,
                    wordBreak: 'break-word'
                }}>
                    <Typography sx={{ mb: 4 }}>
                        Сервис «Аквариум» (далее — «Сервис»), расположенный по адресу&nbsp;
                        <JoyLink href="https://aquarium.org.ru" target="_blank">https://aquarium.org.ru</JoyLink>, придерживается политики нулевой терпимости в отношении сексуального насилия над детьми и их эксплуатации (Child Sexual Abuse and Exploitation, далее — «CSAE»). Настоящий документ описывает наши стандарты, направленные на предотвращение, выявление и пресечение подобного контента и поведения в Сервисе.
                    </Typography>

                    <Typography level="title-lg" sx={{ mb: 2 }}>1. Полный запрет CSAE</Typography>
                    <Typography sx={{ mb: 4 }}>
                        В Сервисе строго запрещены любой контент и любое поведение, связанные с сексуальным насилием над несовершеннолетними или их эксплуатацией. Это включает, помимо прочего: материалы с сексуальным насилием над детьми (CSAM), сексуализацию несовершеннолетних, груминг, вымогательство интимных материалов, торговлю детьми и любые попытки установить с несовершеннолетним контакт в сексуальных целях. Несовершеннолетним считается любое лицо, не достигшее 18 лет. Нарушение этого запрета влечёт немедленную блокировку и удаление контента.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>2. Соответствие требованиям</Typography>
                    <Typography sx={{ mb: 4 }}>
                        Настоящие стандарты соответствуют законодательству Российской Федерации о защите детей от информации, причиняющей вред их здоровью и развитию, а также политике Google Play в отношении сексуального насилия над детьми и их эксплуатации, опубликованной по адресу:&nbsp;
                        <JoyLink href="https://support.google.com/googleplay/android-developer/answer/14747720" target="_blank">support.google.com/googleplay/android-developer/answer/14747720</JoyLink>.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>3. Модерация и выявление</Typography>
                    <Typography sx={{ mb: 4 }}>
                        Мы применяем меры по выявлению и удалению запрещённого контента, включая обработку жалоб пользователей и реагирование на выявленные нарушения. Контент, нарушающий настоящие стандарты, удаляется, а учётные записи нарушителей блокируются. Мы стремимся реагировать на обоснованные жалобы, связанные с CSAE, в кратчайшие возможные сроки.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>4. Как сообщить о нарушении</Typography>
                    <Typography sx={{ mb: 2 }}>
                        Если вы столкнулись с контентом или поведением, нарушающим настоящие стандарты, вы можете сообщить об этом любым из способов:
                    </Typography>
                    <Typography component="div" sx={{ mb: 4 }}>
                        • в приложении — с помощью функции «Пожаловаться», доступной для записей, сообщений и профилей пользователей;<br />
                        • по электронной почте — написав на адрес <JoyLink href="mailto:daniil@dybka.ru">daniil@dybka.ru</JoyLink> с пометкой «Безопасность детей».
                    </Typography>
                    <Typography sx={{ mb: 4 }}>
                        Каждое обращение рассматривается, а к нарушителям применяются меры вплоть до блокировки учётной записи и удаления контента.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>5. Взаимодействие с уполномоченными органами</Typography>
                    <Typography sx={{ mb: 4 }}>
                        При выявлении материалов или действий, связанных с CSAE, мы предпринимаем меры в соответствии с применимым законодательством, включая удаление контента, блокировку нарушителей и, при необходимости, передачу информации компетентным органам и профильным организациям по защите детей.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>6. Ответственное контактное лицо</Typography>
                    <Typography sx={{ mb: 4 }}>
                        Вопросы безопасности детей в Сервисе курирует ответственное контактное лицо. По вопросам, связанным с настоящими стандартами, а также для срочных обращений по фактам CSAE, вы можете связаться с нами по адресу: <JoyLink href="mailto:daniil@dybka.ru">daniil@dybka.ru</JoyLink>.
                    </Typography>

                    <Divider sx={{ my: 5 }} />

                    <Typography level="title-lg" sx={{ mb: 2 }}>7. Изменения стандартов</Typography>
                    <Typography>
                        Мы можем обновлять настоящие стандарты. Актуальная версия всегда доступна на данной странице. Дата последнего обновления указана в начале документа.
                    </Typography>
                </Box>
            </Container>
        </AppBasic>
    );
}

export default PageChildSafety;
